(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.air-menu-toggle').forEach(toggle=>{const nav=document.getElementById(toggle.getAttribute('aria-controls'));if(!nav)return;toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open)});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('is-open')}))})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["air-premium-home"] && !Shopify.designMode) return;
  try {
    
function initAirBestsellers(root=document){root.querySelectorAll('.air-bestsellers').forEach(section=>{if(section.dataset.sliderReady)return;section.dataset.sliderReady='true';const track=section.querySelector('[data-air-slider]');if(!track)return;const move=direction=>{const card=track.querySelector('.air-bestsellers__card');const styles=getComputedStyle(track);const gap=parseFloat(styles.columnGap||styles.gap)||16;track.scrollBy({left:direction*((card?.getBoundingClientRect().width||320)+gap)*2,behavior:'smooth'})};section.querySelector('[data-air-slider-prev]')?.addEventListener('click',()=>move(-1));section.querySelector('[data-air-slider-next]')?.addEventListener('click',()=>move(1))})}
initAirBestsellers();
document.addEventListener('shopify:section:load',event=>initAirBestsellers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
